export default __webpack_public_path__ + "static/media/tj.085b4e0d.png";